var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-100 my-4 col-12",style:({ height: _vm.getHeight() }),attrs:{"styles":_vm.styles}},[_c('h2',{staticClass:"separator-title"},[_vm._v(_vm._s(_vm.label))]),(_vm.showLine)?_c('hr'):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }